import { z } from 'zod';

export const RealEstateSchema = z.object({
  ID: z.string().uuid(),
  PersonID: z.string().uuid(),
  Source: z.string().nullable(),
  FetchID: z.string().nullable().optional(),

  OwnershipType: z.string().optional().nullable(),
  RealEstateType: z.string().optional().nullable(),

  EstimatedValueReferenceNumber: z.string().optional().nullable(),

  TotalMarketValueEstimate: z.number().optional().nullable(),
  TotalMarketValueEstimateApproved: z.number().optional().nullable(),

  MarketScoreArea: z.number().optional().nullable(),
  MarketScoreMunicipality: z.number().optional().nullable(),

  SectionNumber: z.string().optional().nullable(),
  StreetName: z.string().optional().nullable(),
  StreetNumber: z.string().optional().nullable(),
  StreetLetter: z.string().optional().nullable(),
  Postcode: z.string().optional().nullable(),
  Municipality: z.string().optional().nullable(),

  CadastreBNumber: z.string().optional().nullable(),
  CadastreFNumber: z.string().optional().nullable(),
  CadastreGNumber: z.string().optional().nullable(),
  CadastreKNumber: z.string().optional().nullable(),
  CadastreSNumber: z.string().optional().nullable(),

  PrimaryLivingArea: z.number().optional().nullable(),

  IsInsured: z.boolean().optional().nullable(),
  InsuranceCompany: z.string().optional().nullable(),

  CooperativeApartmentCommonDebt: z.number().optional().nullable(),
  CooperativeApartmentOrganizationNumber: z.string().optional().nullable(),
  CooperativeApartmentShareNumber: z.string().optional().nullable(),
});

export type RealEstate = z.infer<typeof RealEstateSchema>;

export const PatchRealEstateSchema = RealEstateSchema.omit({
  ID: true,
  PersonID: true,
});

export type PatchRealEstate = z.infer<typeof PatchRealEstateSchema>;

export const CreateRealEstateSchema = RealEstateSchema.omit({
  ID: true,
});

export type CreateRealEstate = z.infer<typeof CreateRealEstateSchema>;

export const LoanApplicationsCollateralSchema = z.object({
  ID: z.string(),
  LoanApplicationID: z.string(),
  CreatedAt: z.string(),
  UpdatedAt: z.string(),
  RealEstateID: z.string(),
});

export type LoanApplicationCollateral = z.infer<
  typeof LoanApplicationsCollateralSchema
>;
